// src/components/PilahSampah/PilahSampahGame.js
import React, { useReducer } from 'react';
import styles from './PilahSampah.module.css';
import { questionsByDifficulty } from '../../gameLogics/pilahSampahData';
import PilahSampahMenuScreen from './PilahSampahMenuScreen';
import PilahSampahLevelScreen from './PilahSampahLevelScreen';
import PilahSampahGameplayScreen from './PilahSampahGameplayScreen';
import Footer from '../Footer';

export const ACTIONS = {
    GO_TO_SCREEN: 'go-to-screen',
    SELECT_DIFFICULTY: 'select-difficulty',
    ANSWER: 'answer',
    CLEAR_FEEDBACK: 'clear-feedback',
    RESTART: 'restart',
};

const SCORE_INCREMENT = 10;
const PROGRESS_INCREMENT = 10;
const WINNING_PROGRESS = 100;

const getRandomQuestion = (difficulty) => {
    const questions = questionsByDifficulty[difficulty];
    return questions[Math.floor(Math.random() * questions.length)];
};

const initialState = {
    screen: 'menu',
    difficulty: 'easy',
    greenScore: 0,
    redScore: 0,
    greenProgress: 0,
    redProgress: 0,
    currentGreenQuestion: null,
    currentRedQuestion: null,
    winner: null,
    feedback: null,
};

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.GO_TO_SCREEN:
            return { ...initialState, screen: action.payload }; // Reset saat pindah layar utama
        case ACTIONS.RESTART:
            return { ...initialState };
        case ACTIONS.SELECT_DIFFICULTY:
            return {
                ...initialState,
                screen: 'game',
                difficulty: action.payload,
                currentGreenQuestion: getRandomQuestion(action.payload),
                currentRedQuestion: getRandomQuestion(action.payload),
            };
        case ACTIONS.ANSWER: {
            if (state.winner) return state; // Jangan lakukan apa-apa jika sudah ada pemenang
            const { team, answer } = action.payload;
            const isGreenTeam = team === 'green';
            const question = isGreenTeam ? state.currentGreenQuestion : state.currentRedQuestion;
            const isCorrect = answer === question.answer;

            let newGreenScore = state.greenScore;
            let newRedScore = state.redScore;
            let newGreenProgress = state.greenProgress;
            let newRedProgress = state.redProgress;
            
            if (isCorrect) {
                if (isGreenTeam) {
                    newGreenScore += SCORE_INCREMENT;
                    newGreenProgress = Math.min(WINNING_PROGRESS, state.greenProgress + PROGRESS_INCREMENT);
                } else {
                    newRedScore += SCORE_INCREMENT;
                    newRedProgress = Math.min(WINNING_PROGRESS, state.redProgress + PROGRESS_INCREMENT);
                }
            }

            const newWinner = newGreenProgress >= WINNING_PROGRESS ? 'green' : newRedProgress >= WINNING_PROGRESS ? 'red' : null;

            return {
                ...state,
                greenScore: newGreenScore,
                redScore: newRedScore,
                greenProgress: newGreenProgress,
                redProgress: newRedProgress,
                currentGreenQuestion: isGreenTeam ? getRandomQuestion(state.difficulty) : state.currentGreenQuestion,
                currentRedQuestion: !isGreenTeam ? getRandomQuestion(state.difficulty) : state.currentRedQuestion,
                winner: newWinner,
                feedback: { team, isCorrect },
            };
        }
        case ACTIONS.CLEAR_FEEDBACK:
            return { ...state, feedback: null };
        default:
            return state;
    }
}

function PilahSampahGame({ onGoHome }) {
    const [state, dispatch] = useReducer(reducer, initialState);

    const renderScreen = () => {
        switch (state.screen) {
            case 'level':
                return <PilahSampahLevelScreen dispatch={dispatch} />;
            case 'game':
                return <PilahSampahGameplayScreen state={state} dispatch={dispatch} />;
            case 'menu':
            default:
                return <PilahSampahMenuScreen dispatch={dispatch} onGoHome={onGoHome} />;
        }
    };

    return (
        <div className={styles.gameContainer}>
            {renderScreen()}
            {/* Tambahkan Footer di sini */}
            <Footer />
        </div>
    );
}

export default PilahSampahGame;